import { useCallback } from 'react';
import { useAuthenticatedFetch as useNsiAuthenticatedFetch } from '@nsi-advisory-services/auth-react';
import {
  IMPERSONATION_HEADER,
  getImpersonatedUserId,
  isImpersonationRefusal,
  stopImpersonating,
} from '../auth/impersonation';

// Sends JSON by default; FormData bodies set their own Content-Type.
// While an admin views the app as another user, every call says who (see auth/impersonation).
const useAuthenticatedFetch = () => {
  const authFetch = useNsiAuthenticatedFetch();

  return useCallback(async (url, options = {}) => {
    const headers = new Headers(options.headers);
    if (!(options.body instanceof FormData) && !headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }
    const impersonatedUserId = getImpersonatedUserId();
    if (impersonatedUserId) headers.set(IMPERSONATION_HEADER, impersonatedUserId);

    const response = await authFetch(url, { ...options, headers });
    if (impersonatedUserId && (await isImpersonationRefusal(response))) stopImpersonating();
    return response;
  }, [authFetch]);
};

export default useAuthenticatedFetch;
